import { axios } from '@/utils/request'

/**
 * 查询问诊订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function baDepartmentPage (parameter) {
  return axios({
    url: '/baDepartment/pageNo',
    method: 'get',
    params: parameter
  })
}

/**
 * 点击备案功能
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function upDataList (parameter) {
  return axios({
    url: '/baDepartment/upLoadJg',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询筛选条件 医院机构下拉框
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function inquiryorderSelect (parameter) {
  return axios({
    url: '/baDepartment/getAllOrgs',
    method: 'get',
    data: parameter
  })
}


/**
 * 添加科室
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function departmentAdd (parameter) {
  return axios({
    url: '/baDepartment/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取父级科室
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function getParentDepartment(parameter) {
  return axios({
    url: '/baDepartment/selectParentDept',
    method: 'get',
    params : parameter
  })
}

/**
 * 获取父级科室
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function getClassDepartment(parameter) {
  return axios({
    url: '/baDepartment/selectDeptClass',
    method: 'get',
    params : parameter
  })
}


/**
 * 查看科室数据
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function getDepartment(parameter) {
  return axios({
    url: '/baDepartment/detail?deptId=' + parameter,
    method: 'get',
  })
}

/**
 * 编辑科室
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function editDepartment (parameter) {
  return axios({
    url: '/baDepartment/edit',
    method: 'post',
    data: parameter,
  })
}



/**
 * 删除科室
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function  removeDepartment(parameter) {
  return axios({
    url: '/baDepartment/deleteDept?deptId=' + parameter,
    method: 'get',
  })
}
